import React from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';

const SelectStyled = styled(ReactSelect)`
  display: block;
  margin: 10px auto;
  border: none;
  width: 100%;
  outline: none;
  font-size: 14px !important;
  font-family: 'Open Sans', sans-serif !important;

  .arnold__control {
    background-color: hsl(0, 0%, 98%);
  }

  .arnold__control--is-disabled {
    background-color: #f1f1f1;
  }
`;

export const Select: React.FC<any> = props => {
  return (
    <SelectStyled isClearable inputId={props.name} {...props} classNamePrefix="arnold">
      {props.children}
    </SelectStyled>
  );
};

export default Select;
